export class WaitlistEntryAuditEntry {
    constructor(
        public id: string,
        public waitlistEntryId: string,
        public changes: { [key: string]: any },
        public userId: string | null,
        public dateTime: Date,
    ) { }
}
